<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        ข้อมูลสัดส่วนการคิดค่าบริการโทรศัพท์เคลื่อนที่
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i>ข้อมูลสัดส่วนการคิดค่าบริการโทรศัพท์เคลื่อนที่
          </a>
        </li>
        <li class="active">ข้อมูลสัดส่วนการคิดค่าบริการโทรศัพท์เคลื่อนที่</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header with-border">
                <h3 class="box-title">แก้ไขสัดส่วนการคิดค่าบริการโทรศัพท์เคลื่อนที่</h3>
              </div>
              <div class="box-body">
                <div class="wrapper_edit_typegroup">
                  <div class="row">
                    <div class="col-sm-6">
                      <el-form size="small">
                        <el-form-item label="สัดส่วนรายการส่งเสริมการขาย (Pre-Paid และ Post-Paid)">
                          <el-input
                            @change="setPercentage('main')"
                            placeholder="กรุณาระบุสัดส่วน"
                            v-model="proportion_main"
                            width="300px"
                            type="number"
                            min="0"
                            max="100"
                            @keypress.native="isNumberKey"
                          ></el-input>
                          <span>%</span>
                        </el-form-item>
                      </el-form>
                    </div>
                    <div class="col-sm-6">
                      <el-form size="small">
                        <el-form-item label="สัดส่วนรายการส่งเสริมการขาย (On-top)">                          
                          <el-input
                            @change="setPercentage('ontop')"
                            placeholder="กรุณาระบุสัดส่วน"
                            v-model="proportion_ontop"
                            width="300px"
                            type="number"
                            min="0"
                            max="100"
                            @keypress.native="isNumberKey"
                          ></el-input>
                          <span>%</span>
                        </el-form-item>
                      </el-form>
                    </div>
                  </div>
                  <div class="box-footer">
                    <el-button type="primary" @click="update({proportion_main,proportion_ontop,id})">ยืนยัน</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      proportion_main:null,
      proportion_ontop:null,
      id:null
    };
  },
  computed: {
    ...mapState({

    })
  },
  mounted() {
    let params = this.$route.params;
    this.proportion_main = params.proportion_main_promotion;
    this.proportion_ontop = params.proportion_ontop_promotion;
    this.id = params.id;
  },
  methods: {
    ...mapActions({
      update:"ManageService/update"
    }),
    setPercentage(col){
      if(col == 'main'){
        this.proportion_ontop = 100 - this.proportion_main
      }else{
        this.proportion_main = 100 - this.proportion_ontop
      }
    }
  }
};
</script>
